import { useContext } from 'react';
import { RoleContext } from '@/contexts/role-context-impl';

export function useRole() {
  const context = useContext(RoleContext);
  if (!context) {
    throw new Error('useRole must be used within a RoleProvider');
  }
  return context;
}